var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisualLayer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 958,
    height: 383.2,
    viewBox: "0 0 958 383.2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visual-layer"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "central-hub-glow",
    cx: 655.432,
    cy: 191.6,
    r: 191.6,
    fill: "url(#paint0_radial_0_139)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 483.529,
    y1: 104.311,
    x2: 655.164,
    y2: 190.542,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    x1: 483.954,
    y1: 104.669,
    x2: 631.646,
    y2: 304.253,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    x1: 436.046,
    y1: 161.675,
    x2: 654.788,
    y2: 190.403,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    x1: 436.554,
    y1: 215.158,
    x2: 654.528,
    y2: 190.435,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    x1: 436.198,
    y1: 215.256,
    x2: 663.723,
    y2: 113.069,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    x1: 482.474,
    y1: 272.749,
    x2: 654.113,
    y2: 190.516,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    x1: 654.171,
    y1: 190.496,
    x2: 732.408,
    y2: 157.764,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    x1: 654.579,
    y1: 190.404,
    x2: 830.191,
    y2: 182.43,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    x1: 655.107,
    y1: 190.501,
    x2: 809.185,
    y2: 256.762,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    x1: 655.581,
    y1: 190.868,
    x2: 701.884,
    y2: 250.743,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    x1: 655.819,
    y1: 191.77,
    x2: 639.855,
    y2: 303.52,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    x1: 435.809,
    y1: 161.903,
    x2: 631.4,
    y2: 307.998,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    x1: 759.48,
    y1: 93.9571,
    x2: 647.713,
    y2: 309.507,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    x1: 653.699,
    y1: 192.349,
    x2: 589.758,
    y2: 112.537,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    x1: 653.464,
    y1: 191.345,
    x2: 670.229,
    y2: 114.705,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    x1: 654.837,
    y1: 190.42,
    x2: 882.362,
    y2: 229.539,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    x1: 653.787,
    y1: 190.754,
    x2: 757.543,
    y2: 86.9975,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    x1: 774.551,
    y1: 89.5048,
    x2: 831.232,
    y2: 166.943,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    x1: 766.746,
    y1: 93.0517,
    x2: 815.444,
    y2: 250.323,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    x1: 841.782,
    y1: 195.966,
    x2: 823.42,
    y2: 251.849,
    stroke: "white",
    strokeOpacity: 0.14902,
    strokeWidth: 2.395
  }), /*#__PURE__*/React.createElement("circle", {
    id: "satellite-node",
    cx: 736.862,
    cy: 155.676,
    r: 6.38667,
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "satellite-node_2",
    cx: 847.032,
    cy: 179.625,
    r: 19.9583,
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "satellite-node_3",
    cx: 820.288,
    cy: 261.455,
    r: 13.9708,
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "satellite-node_4",
    cx: 700.936,
    cy: 254.669,
    r: 7.185,
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "satellite-node_5",
    cx: 639.465,
    cy: 316.139,
    r: 14.37,
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "satellite-node_6",
    cx: 579.191,
    cy: 98.5949,
    r: 19.5592,
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "satellite-node_7",
    cx: 670.6,
    cy: 110.169,
    r: 7.98333,
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "satellite-node_8",
    cx: 896.528,
    cy: 230.718,
    r: 14.37,
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "satellite-node_9",
    cx: 765.202,
    cy: 81.8302,
    r: 13.9708,
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "central-hub-node",
    cx: 654.633,
    cy: 191.601,
    r: 23.95,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(655.432 191.6) rotate(90) scale(191.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798077,
    stopColor: "#999999",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualLayer);
export default __webpack_public_path__ + "static/media/visual_layer.f07a23f2546b66f44eb8b61cbfa7a6fc.svg";
export { ForwardRef as ReactComponent };